import React, { useEffect, useState } from 'react';
import { WithTranslations, withTranslations } from '../../../utils/withTranslations';
import { BILoggerStore } from '../../stores/BILoggerStore';
import { injectStoresV2 } from '../../stores/injectStoresV2';
import { RoutingStore } from '../../stores/RoutingStore';

import s from './TopControls.scss';

const BLANK_TEMPLATE_ID = 'b55bdf43-95e0-4cef-b9bb-92dcc7af2742';

interface TopControlsProps extends WithTranslations {
  routingStore: RoutingStore;
  biLoggerStore: BILoggerStore;
}

const TopControlsCmp: React.FC<TopControlsProps> = ({ biLoggerStore, routingStore, t }) => {
  const [showControls, setShowControls] = useState(false);
  const [showBackButton, setShowBackButton] = useState(false);

  const handleBack = () => {
    biLoggerStore.logClickOnElement({ clickedElement: 'back' });
    window.history.back();
  };

  const handleSkip = () => {
    biLoggerStore.logClickOnElement({ clickedElement: 'skip' });
    const url = `https://manage.wix.com/edit-template/to-dashboard-new?originTemplateId=${BLANK_TEMPLATE_ID}`;
    window.location.assign(url);
  };

  useEffect(() => {
    const { ref } = routingStore.getGlobalUrlParams();
    if (ref && ref === 'entry-from-chat-msg') {
      setShowControls(true);
    } else if (ref && ref === 'entry-from-chat') {
      setShowControls(true);
      setShowBackButton(true);
    }
  }, []);

  if (!showControls) {
    return null;
  }

  return (
    <div className={s.topControls}>
      {showBackButton ? (
        <div className={s.back} onClick={handleBack}>
          {t('fromChat.topControl.back')}
        </div>
      ) : (
        <div></div>
      )}
      <div className={s.skip} onClick={handleSkip}>
        {t('fromChat.topControl.skip')}
      </div>
    </div>
  );
};

export const TopControls = withTranslations(injectStoresV2('routingStore', 'biLoggerStore')(TopControlsCmp));
